import { StatusMarkerIconVariant } from '../../../../interfaces/props/StatusMarkerIconProps';
import { TranscricaoHistoricoStatus } from '../../../../interfaces/entities/Transcricao/TranscricaoHistoricoStatus';
import { formatTranscricaoDataCompleta } from './transcricaoDetalheUtils';

export type TimelineStepState = 'completed' | 'current' | 'pending';
export type TimelineStepVariant = 'default' | 'alert' | 'success';

export interface TranscricaoTimelineStep {
  id: string;
  markerVariant: StatusMarkerIconVariant;
  title: string;
  description: string;
  date: string;
  variant: TimelineStepVariant;
  state: TimelineStepState;
  showResolver: boolean;
}

const STATUS_EM_ANALISE = new Set(['ANALIS', 'PROCIA', 'POS-IA', 'ANALISE']);

const COPY_EM_ANALISE = {
  title: 'Transcrição em análise',
  description: 'Nossa equipe está avaliando sua solicitação.',
  date: '',
} as const;

const COPY_FINALIZADO_TITULO = 'Finalizado';

const STATUS_MARKER_VARIANT: Record<string, StatusMarkerIconVariant> = {
  CRIADA: 'enviada',
  ENTREG: 'enviada',
  ANALIS: 'revisao',
  PROCIA: 'revisao',
  'POS-IA': 'revisao',
  ANALISE: 'revisao',
  SOLINF: 'pendencia',
  PENENV: 'pendenciaEnviada',
  FINALI: 'autorizada',
};

const resolveMarkerVariant = (cod?: string | null): StatusMarkerIconVariant => {
  if (!cod?.trim()) return 'revisao';
  return STATUS_MARKER_VARIANT[cod.trim().toUpperCase()] ?? 'revisao';
};

const resolveStepVariant = (cod?: string | null): TimelineStepVariant => {
  const normalized = cod?.trim().toUpperCase();
  if (normalized === 'SOLINF') return 'alert';
  if (normalized === 'FINALI') return 'success';
  return 'default';
};

const formatHistoricoDataOperacao = (raw?: string): string => {
  const formatted = formatTranscricaoDataCompleta(raw);
  return formatted === '—' ? '' : formatted;
};

const resolveStepCopy = (
  cod: string,
  item: TranscricaoHistoricoStatus,
): { title: string; description: string; date: string } => {
  if (STATUS_EM_ANALISE.has(cod)) {
    return { ...COPY_EM_ANALISE };
  }

  const date = formatHistoricoDataOperacao(item.dataOperacao);
  const descrStatus = item.descrStatusTranscricao?.trim() || '';

  if (cod === 'FINALI') {
    return {
      title: COPY_FINALIZADO_TITULO,
      description: descrStatus,
      date,
    };
  }

  return {
    title: descrStatus || cod || '—',
    description: '',
    date,
  };
};

export const mapHistoricoSumarioToTimeline = (
  itens: TranscricaoHistoricoStatus[],
): TranscricaoTimelineStep[] => {
  if (!itens.length) return [];

  const lastIndex = itens.length - 1;

  return itens.map((item, index) => {
    const cod = item.codStatusTranscricao?.trim().toUpperCase() ?? '';
    const state: TimelineStepState = index === lastIndex ? 'current' : 'completed';
    const { title, description, date } = resolveStepCopy(cod, item);

    return {
      id: `${cod || 'status'}-${index}`,
      markerVariant: resolveMarkerVariant(cod),
      title,
      description,
      date,
      variant: resolveStepVariant(cod),
      state,
      showResolver: cod === 'SOLINF' && state === 'current',
    };
  });
};
